<template>
  <div
    :class="[
      s.wrap,
      s[helper.displayDirection],
      `request_${helper.displayDirection}`,
      'request',
    ]">

    <!-- タイムライン -->
    <Timeline />

    <!-- 新バージョン：通常配車依頼・デマンド両方表示 -->
    <div ref="scrollContainer" :class="s2.container">
      <!-- request -->
      <div :class="[s2.section]" v-if="user.requests.length || user.dispatchRequests.length">
        <div :class="s2.section_content">
          <ul :class="s2.item_list">
            <li
              v-for="rqt in user.requests" :key="rqt.id"
              :class="s2.item_list_item">
              <div :class="s2.item_list_title">
                <span>{{ formatTimestamp(rsvData(rqt.reservation).datetime, 'HH:mm') }}</span>
                <span v-if="rqt.reservation.user"><i :class="userType(rqt.reservation.user, rqt.reservation.route).styleClass" class="ms-2"></i></span>
                <span class="ms-1">{{ rsvData(rqt.reservation).customerName }}</span>
              </div>
              <div :class="[s2.item_list_content, s2.flex]">
                <div :class="s2.item_left">
                  <div :class="s2.item_locations">
                    <div
                      v-for="(loc, i) in rsvData(rqt.reservation).locations" :key="i"
                      @click="mapWindowOpen({ lat: loc.lat, lng: loc.lng })">
                      <div class="d-flex flex-wrap">
                        <div :class="s2.location_title" class="me-3">
                          <span v-if="loc.landmark_label" :class="s2.landmark_label">{{ loc.landmark_label }}</span>
                          <span v-if="loc.title">{{ loc.title }}</span>
                        </div>
                        <div v-if="loc.address">
                          <span>{{ removeZipPref(loc.address) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="rsvData(rqt.reservation).memo" class="mt-2">{{ rsvData(rqt.reservation).memo }}</div>
                </div>
                <div :class="s2.item_right">
                  <LargeBtn
                    @click="updateRequest({ flag: 11, id: rqt.id, code: rqt.reservation.code  })"
                    :class="s2.btn_120">了解</LargeBtn>
                </div>
              </div>
            </li>
            <!-- dispatchRequests -->
            <li
              v-for="rqt in user.dispatchRequests" :key="rqt.id"
              :class="s2.item_list_item">
              <div :class="s2.item_list_title">
                <span>{{ dispatchTime(rqt.dispatch) }}</span>
                <!-- <span v-if="rqt.dispatch.passengers?.[0]"><i :class="userType(rqt.dispatch.user).styleClass" class="ms-2"></i></span> -->
                <span class="ms-2" v-if="rqt.dispatch.passengers[0]?.user">{{ rqt.dispatch.passengers[0].user?.username }} 様</span>
              </div>
              <div :class="[s2.item_list_content, s2.flex]">
                <div :class="s2.item_left">
                  <div :class="s2.item_locations">
                    <div
                      v-for="(loc, i) in dispatchLocations(rqt.dispatch)" :key="i"
                      @click="mapWindowOpen({ lat: loc.lat, lng: loc.lng })">
                      <div class="d-flex flex-wrap">
                        <div :class="s2.location_title" class="me-3">
                          <span v-if="loc.landmark_label" :class="s2.landmark_label">{{ loc.landmark_label }}</span>
                          <span v-if="loc.title">{{ loc.title }}</span>
                        </div>
                        <div v-if="loc.address">
                          <span>{{ removeZipPref(loc.address) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-if="rsvData(rqt.reservation).memo" class="mt-2">{{ rsvData(rqt.reservation).memo }}</div> -->
                </div>
                <div :class="s2.item_right">
                  <LargeBtn
                    @click="updateDispatchRequest({ flag: 11, id: rqt.id, dispatchCode: rqt.dispatch.code })"
                    :class="s2.btn_120">了解</LargeBtn>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- reservation -->
      <div :class="[s2.section]">
        <div :class="s2.section_content">
          <ul :class="s2.item_list">
            <!-- 配車 -->
            <li
              v-for="item in scheduleItemsReverse" :key="item.raw.id"
              :data-item-id="`${item.type}-${item.code}`"
              @click="jump2orderDetail(item.type, item.raw)"
              :class="s2.item_list_item"
              :style="{
                opacity: itemStatusColor(item).isActive ? 1 : 0.4,
                border: topPriortyItem?.type === item.type && topPriortyItem?.code === item.code ? `6px solid ${itemStatusColor(item).color}` : 'none',
              }">
              <!-- reservation -->
              <template v-if="item.type === 'reservation'">
                <div :class="s2.item_list_title" :style="{ borderLeft: `12px solid ${itemStatusColor(item).color}` }">
                  <span>{{ formatTimestamp(itemData(item.raw).datetime, 'HH:mm') }}</span>
                  <span v-if="item.raw.user"><i :class="userType(item.raw.user, item.raw.route).styleClass" class="ms-2"></i></span>
                  <span class="ms-1">{{ itemData(item.raw).customerName }}</span>
                </div>
                <div :class="[s2.item_list_content]">
                  <div :class="s2.item_left">
                    <div :class="s2.item_locations">
                      <div v-for="(loc, i) in itemData(item.raw).locations" :key="i">
                        <div class="d-flex flex-wrap">
                          <div :class="s2.location_title" class="me-3">
                            <span v-if="loc.landmark_label" :class="s2.landmark_label">{{ loc.landmark_label }}</span>
                            <span v-if="loc.title">{{ loc.title }}</span>
                          </div>
                          <div v-if="loc.address">
                            <span>{{ removeZipPref(loc.address) }}</span>
                          </div>
                        </div>
                        <div v-if="item.raw.foreign_type === 31">
                          <i :class="`me-1 fa-solid fa-circle-arrow-${loc.type === 'pickup' ? 'up' : 'down'}`"></i>
                          <i :class="userType(loc.customer.user, loc.customer.route).styleClass" class="me-1"></i>
                          <span>{{ loc.customer.user?.username }} 様</span>
                        </div>
                      </div>
                    </div>
                    <!-- 通常配車の場合のメモ -->
                    <div v-if="itemData(item.raw).memo" class="mt-2">{{ itemData(item.raw).memo }}</div>
                  </div>
                  <!-- demandの場合のメモ -->
                  <div v-if="itemData(item.raw).memos?.length" class="pt-2 mt-2 bdr-t">
                    <div
                      v-for="(memo,i) in itemData(item.raw).memos" :key="i"
                      class=""
                      :class="i !== 0 && 'mt-2'">
                      <span :class="s2.memo_user">{{ memo.username }} 様</span>
                      <span class="n2br d-block">{{ memo.memo }}</span>
                    </div>
                  </div>
                </div>
              </template>

              <!-- dispatches -->
              <template v-if="item.type === 'dispatch'">
                <div :class="s2.item_list_title" :style="{ borderLeft: `12px solid ${itemStatusColor(item).color}` }">
                  <span>{{ dispatchTime(item.raw) }}</span>
                  <span class="ms-2" v-if="item.raw.passengers.length === 1">{{ item.raw.passengers[0].user?.username ? `${item.raw.passengers[0].user?.username} 様` : '' }}</span>
                  <span class="ms-2" v-else>乗合</span>
                </div>
                <div :class="[s2.item_list_content]">
                  <div :class="s2.item_left">
                    <div :class="s2.item_locations">
                      <div v-for="(loc, i) in dispatchLocations(item.raw)" :key="i">
                        <div class="d-flex flex-wrap">
                          <div :class="s2.location_title" class="me-3">
                            <span v-if="loc.landmark_label" :class="s2.landmark_label">{{ loc.landmark_label }}</span>
                            <span v-if="loc.title">{{ loc.title }}</span>
                          </div>
                          <div v-if="loc.address">
                            <span>{{ removeZipPref(loc.address) }}</span>
                          </div>
                        </div>
                        <div v-if="item.raw.foreign_type === 31">
                          <i :class="`me-1 fa-solid fa-circle-arrow-${loc.type === 'pickup' ? 'up' : 'down'}`"></i>
                          <i :class="userType(loc.customer.user, loc.customer.route).styleClass" class="me-1"></i>
                          {{ loc.customer.user.username }} 様
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- メモ -->
                  <div v-if="dispatchMemos(item.raw).length" class="pt-2 mt-2 bdr-t">
                    <div
                      v-for="(memo,i) in dispatchMemos(item.raw)" :key="i"
                      class=""
                      :class="i !== 0 && 'mt-2'">
                      <span :class="s2.memo_user">{{ memo.user.username }} 様</span>
                      <span class="n2br d-block">{{ memo.memo }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  LargeBtn,
  Timeline,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'request',
  mixins: [cf],
  components: {
    LargeBtn,
    Timeline,
  },
  data() {
    return {
      sliderInitIdx: 0,
    };
  },
  created() {},
  computed: {
    ...mapState(['user', 'helper', 'dispatch']),
    itemLoaded() {
      return this.dispatch.isLoadedFirst.all;
    },
    scheduleItems() {
      return this.dispatch.scheduleItems;
    },
    scheduleItemsReverse() {
      const reverse = [...this.dispatch.scheduleItems].reverse();
      return reverse;
    },
    topPriortyItem() {
      const notCompletedScheduleItems = this.scheduleItems
        .filter((item) => ['reservation', 'dispatch'].includes(item.type))
        .filter((item) => !this.isCompleted(item));
      return notCompletedScheduleItems.reduce((cur, acc) => (cur.start < acc.start ? cur : acc), notCompletedScheduleItems[0]);
    },
    assignedSche() {
      return this.assignedDemand(this.user);
    },
    driverReservations() {
      if (!this.user.orders || !this.user.orders.length) return [];
      // 日時順にソート(降順)
      return [...this.user.orders].sort((a, b) => new Date(b.reservation_time) - new Date(a.reservation_time));
    },
    driverHistories() {
      const getStart = (rsv) => {
        const cusDatetimes = rsv.demandCustomers.filter((dc) => dc.flag <= 31).map((cus) => new Date(cus.p_datetime));
        return cusDatetimes.reduce((a, c) => (a < c ? a : c), cusDatetimes[0]);
      };
      // 予約開始日時降順に並び替え
      const sortedHistories = [...this.histories].sort((a, b) => {
        const aDatetime = a.foreign_type === 31 ? getStart(a) : a.datetime || a.created_at;
        const bDatetime = b.foreign_type === 31 ? getStart(b) : b.datetime || b.created_at;
        return new Date(bDatetime) - new Date(aDatetime);
      });
      return sortedHistories.map((rsv) => ({
        ...rsv,
        reservation_date: rsv.foreign_type === 31 ? getStart(rsv) : rsv.datetime || rsv.created_at,
      }));
    },
  },
  watch: {
    user: {
      handler() {
        this.scrollToTopPriority();
        this.hideLoading();
      },
      deep: true,
      immediate: true,
    },
    itemLoaded: {
      handler() {
        this.scrollToTopPriority();
      },
      immediate: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    isCompleted(item) {
      const COMPLETED_FLAG = 31;
      if (item.type === 'reservation') {
        if (item.raw.foreign_type === 31) return item.raw.demandCustomers.every((dc) => dc.flag >= COMPLETED_FLAG);
        return item.raw.order?.flag >= 31;
      }
      if (item.type === 'dispatch') return item.raw.passengers.every((p) => p.flag >= COMPLETED_FLAG);
      return true;
    },
    itemStatusColor(item) {
      return this.itemStatus(item, this.helper.master);
    },
    dispatchLocations(dispatch) {
      return dispatch.passengers.flatMap((p) => p.passengerLocations);
    },
    dispatchTime(dispatch) {
      const start = this.dispatchLocations(dispatch)[0];
      return start ? this.formatTimestamp(start.datetime, 'HH:mm') : '--';
    },
    dispatchMemos(dispatch) {
      const passengerMemos = [];
      dispatch.passengers.forEach((p) => {
        if (p.memo) passengerMemos.push({ user: p.user, ...p.memo });
      });
      return passengerMemos;
    },

    rsvData(reservation) {
      const locations = [
        {
          title: reservation.p_title,
          address: reservation.p_address,
          lat: reservation.p_lat,
          lng: reservation.p_lng,
        },
        ...(reservation.waypoints || []),
      ];

      if (reservation.d_lat) {
        locations.push({
          title: reservation.d_title,
          address: reservation.d_address,
          lat: reservation.d_lat,
          lng: reservation.d_lng,
        });
      }

      return {
        datetime: new Date(reservation.datetime || reservation.created_at),
        customerName: reservation.user?.username ? `${reservation.user?.username} 様` : reservation.course?.label,
        memo: reservation.memo?.memo,
        locations,
      };
    },

    demandData(reservation) {
      const customers = reservation.demandCustomers.sort((a, b) => (new Date(a.p_datetime) < new Date(b.p_datetime) ? 1 : 0));
      const locations = customers.flatMap((cus) => [
        {
          type: 'pickup',
          datetime: cus.p_datetime,
          title: cus.p_title,
          address: cus.p_address,
          lat: cus.p_lat,
          lng: cus.p_lng,
          landmark_label: cus.pLandmark?.landmark_label,
          customer: cus,
        },
        {
          type: 'destination',
          datetime: cus.d_datetime,
          title: cus.d_title,
          address: cus.d_address,
          lat: cus.d_lat,
          lng: cus.d_lng,
          landmark_label: cus.dLandmark?.landmark_label,
          customer: cus,
        },
      ]).sort((a, b) => (new Date(a.p_datetime) < new Date(b.p_datetime) ? 1 : 0));
      const memos = customers
        .map((c) => ({ memo: c.memo?.memo, username: c.user.username }))
        .filter((m) => m.memo);

      return {
        datetime: customers[0].p_datetime,
        customerName: reservation.demandSchedule.demandArea.label,
        customers,
        locations,
        memos,
      };
    },

    itemData(reservation) {
      if (reservation.foreign_type !== 31) return this.rsvData(reservation);
      return this.demandData(reservation);
    },

    userType(user, route) {
      const styleClass = [
        this.s2.userType_icon,
        [1, 5].includes(route) ? 'fa-solid fa-comments' : 'fa-solid fa-phone',
        user.lineUser ? this.s2.line_green : this.s2.tel_blue,
      ];
      return {
        type: user.lineUser ? 'line' : 'tel',
        styleClass,
      };
    },

    mapWindowOpen({ lat, lng }) {
      if (!lat || !lng) return;
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`, '_blank');
    },

    updateRequest({ flag, id }) {
      this.showLoading();
      const data = {
        user_id: this.user.id,
        request_id: id,
        from_user_type: 'driver',
        flag,
      };

      this.axios({
        method: 'POST',
        url: '/v1/request/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.message === 'Already created order.') {
            alert('他のドライバーが、この配車を承認しているため、処理できませんでした。');
            this.$store.dispatch('user/update', null, { root: true });
          }
          // if (flag === 11) this.$router.push(`/order/?type=reservation&code=${code}`);
        })
        .catch((error) => {
          if (error.response?.data?.message === 'Request.reservation or Request.user.offices not found.' || error.response?.data?.message === 'Update request not found.') {
            alert('この依頼は、取り下げられたか、すでに配車が確定されていたため、受けることができませんでした。');
            this.$store.dispatch('user/update', null, { root: true });
          }
          if (error.response) console.log(error.response.data);
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('user/update');
          this.$store.dispatch('dispatch/getReservations', { hideLoading: true });
          // ネイティブアプリのバッジ更新
          cf.updateNativeAppBadges(this.helper);
        });
    },

    updateDispatchRequest({ flag, id }) {
      this.showLoading();
      const data = {
        requestId: id,
        editorId: this.user.id,
        flag,
      };

      this.axios({
        method: 'POST',
        url: '/v1/dispatch/update/request',
        data,
      })
        .then(() => {
        })
        .catch((error) => {
          if (error.response?.data?.errorCode === 'REQUEST_ALREADY_CANCELED') alert('この依頼は、取り下げられたか、すでに配車が確定されていたため、受けることができませんでした。');
          if (error.response) console.log(error.response.data);
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('dispatch/getDispatches', { hideLoading: true });
          this.$store.dispatch('user/update');
          this.hideLoading();
          // ネイティブアプリのバッジ更新
          cf.updateNativeAppBadges(this.helper);
        });
    },

    scrollToTopPriority() {
      // ユーザ情報がない(リクエストのデータがない)　または アイテムが読み込み完了していない 場合にはreturn
      if (!this.user.id || !this.itemLoaded) return;
      // リクエストがある場合にはそのまま一番上でOKなので return
      if (this.user.requests?.length || this.user.dispatchRequests?.length) return;

      // topPriorityItemがあればその予約の位置までスクロール
      if (!this.topPriortyItem) return;
      this.$nextTick(() => {
        const itemId = `${this.topPriortyItem.type}-${this.topPriortyItem.code}`;
        const el = this.$el.querySelector(`[data-item-id="${itemId}"]`);
        if (!el) return;
        const container = this.$refs.scrollContainer;
        if (!container) return;
        const offset = el.offsetTop - 45;
        container.scrollTo({ top: offset });
      });
    },

    jump2orderDetail(type, reservation) {
      this.$router.push(`/order/?code=${reservation.code}&type=${type}`);
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  background-color: var(--bg-dark);
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    height: 100%;
    flex: 1;
    overflow: scroll;
  }
}

.card_container {
  padding: 0 60px;
  height: 100%;
  .slide {
    height: 100%;
  }
}

.card {
  height: 100%;
  // box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  // border-radius: 8px;
  display: flex;
  flex-direction: column;
  // border: 1px solid var(--border-gray);
  &_header {
    border-bottom: 1px solid var(--border-gray);
    padding: 4px 12px;
    background-color: var(--bg-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &_body {
    flex: 1;
    padding: 0 12px;
    overflow: scroll;
    background-color: #ffffff;
    &_content {
      height: 100%;
      overflow: scroll;
    }
  }
}

.reservation {
  position: relative;
  height: fit-content;
  display: flex;
  padding-top: 12px;
  > :nth-child(1) {
    flex: 1;
  }
  > :nth-child(2) {
    width: 150px;
    display: flex;
    flex-direction: column;
    > :not(:first-child) {
      margin-top: 6px;
    }
  }
}

.status_btns {
  margin-left: 12px;
}

.locations {
  > *:not(:first-child) {
    position: relative;
    margin-top: 12px;
    &::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 12px;
      width: 8px;
      height: 12px;
      background-color: var(--border-gray);
    }
  }
}
.location {
  width: 100%;
  text-align: left;
  background-color: var(--bg-gray);
  border-radius: 4px;
  display: flex;
  align-items: stretch;
  > * {
    padding: 4px 8px;
  }
  > :nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 30px;
    flex-shrink: 0;
    border-right: 1px solid var(--border-gray);
  }
  > :nth-child(2) {
    // text-decoration: underline;
    flex: 1;
  }
}

.results {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--border-gray);
  margin-bottom: 12px;
}

.btns {
  > * {
    display: block;
    width: 200px;
    margin: 0 auto;
  }
}

.completed {
  // margin-top: 24px;
}

// windowサイズが縦長の時
.wrap.vertical {
  .content {}
  .card_container {
    padding: 0  0 60px 0;
  }
  .reservation {
    flex-direction: column;
  }
  .status_btns {
    width: 100%;
    margin-left: 0;
    flex-direction: row;
    padding-top: 12px;
    background-color: #ffffff;
    > * {
      &:not(:first-child) {
        margin-top: 0;
        margin-left: 6px;
      }
    }
  }
}
</style>

<style lang="scss" module="s2">
.timeline_section {
  border-bottom: 2px solid var(--border-gray);
  margin-bottom: 12px;
}
.container {
  flex: 1;
  overflow: scroll;
}
.section {
  position: relative;
  &.first {
    .section_title {
      border-top: none;
    }
  }
  .section_title {
    position: sticky;
    top: 0;
    padding: 12px;
    font-weight: bold;
    border-bottom: 2px solid var(--border-gray);
    border-top: 2px solid var(--border-gray);
    background-color: #ffffff;
    z-index: 10;
  }
  .section_content {
    padding: 12px;
  }
}

.item_list {
  .item_list_item {
    background-color: #ffffff;
    border-radius: 6px;
    // box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    // border: 1px solid var(--border-gray);
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    overflow: hidden;
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
  .item_list_title {
    padding: 6px 12px;
    background-color: var(--bg-gray);
    border-left: 12px solid var(--mitt-blue);
    border-bottom: 1px solid var(--border-gray);
    font-weight: bold;
  }
  .item_list_content {
    padding: 12px;
    &.flex {
      display: flex;
      align-items: flex-start;
    }
  }
  .item_left {
    flex: 1;
  }
  .item_right {
    margin-left: 12px;
  }
  .item_locations {
    flex: 1;
    > div {
      padding: 4px 12px;
      background-color: var(--bg-gray);
      border-radius: 4px;
      position: relative;
      &:not(:first-child) {
        margin-top: 12px;
        &::after {
          position: absolute;
          content: '';
          bottom: 100%;
          left: 12px;
          width: 6px;
          height: 12px;
          background-color: var(--border-gray);
        }
      }

      .location_title {
        display: flex;
        align-items: flex-start;
        font-weight: bold;
      }

      .landmark_label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: calc(24px * 0.3);
        height: 24px;
        padding: 0 12px;
        font-size: 16px;
        margin-right: 6px;
        color: #ffffff;
        background-color: var(--mitt-blue);
        border-radius: 4px;
        font-weight: bold;
      }
    }
  }
}
.btn_120 {
  width: 120px;
}
.userType_icon {
  font-size: 18px;
  &.line_green {
    color: var(--line-green);
  }
  &.tel_blue {
    color: var(--mitt-blue);
  }
}
.loading {
  margin: 32px;
  display: flex;
  justify-content: center;
}
.memo_user {
  // border: 1px solid var(--label-primary);
  background-color: var(--bg-gray);
  padding: 2px 6px;
  border-radius: 6px;
  margin-bottom: 6px;
  display: block;
  width: fit-content;
}
</style>
